<template>
  <div class="position-relative">
    <!-- <div :class="poll.can_be_blurred && (poll.user.id !== authUser.user.id || poll.user.role !== authUser.user.role) ? 'blur position-relative' : 'position-relative'"> -->
    <div
      @click="handleCloseAll"
      :class="`shadow-card br0 br8m0`"
      :style="
        poll.user_role === 'doctor' || poll.user_role === 'physician' || poll.user_role === 'ohcp' || poll.user_role === 'hcp'
          ? 'background: #F8FEFF'
          : poll.user_role === 'admin'
          ? 'background: #F0FFFA'
          : poll.user_role === 'hospital_administrator' || poll.user_role === 'clinic_administrator' || poll.user_role === 'nfp_administrator' || poll.user_role === 'business_administrator'
          ? 'background: #FFFCF5'
          : 'background: #FFFFFF'
      "
    >
      <div class="post-head position-relative mb-2">
        <div :class="`title ${poll.user.deactivated ? 'no-click' : 'cp'}`">
          <a @click="viewProfile" href="#">
            <a-avatar
              :style="{ color: ' #ffffff !important', 'background-color': poll.user.url ? '' : getAvatarColor(poll.user.id) }"
              :size="70"
              class="post-list-image text-uppercase"
              :src="!poll.user.deactivated ? poll.user.url || '' : null"
              alt="avatar"
            >
              {{ poll.user.deactivated ? "AU" : getPollUserInitials }}
            </a-avatar>
          </a>
        </div>
        <div :class="`my-auto ${poll.user.deactivated && 'no-click'}`">
          <div class="cp d-flex align-items-center name-with-poll pr-3 flex-wrap">
            <p class="m-0 p-0 cp text-capitalize" @click="viewProfile" v-if="poll.user.role === 'patient' || poll.user.role === 'caregiver'">
              {{ poll.user.deactivated ? "Anonymous User" : poll.user.display_name }}
            </p>
            <p
              class="m-0 p-0 cp text-capitalize"
              @click="viewProfile"
              v-if="poll.user.role === 'clinic_administrator' || poll.user.role === 'hospital_administrator' || poll.user.role === 'nfp_administrator' || poll.user_role === 'business_administrator'"
            >
              {{ poll.user.deactivated ? "Anonymous User" : poll.user.display_name }}
            </p>
            <p class="m-0 p-0 cp text-capitalize" @click="viewProfile" v-if="poll.user.role === 'advocate'">
              {{ poll.user.deactivated ? "Anonymous User" : poll.user.display_name || "A" }}
              <!-- {{ poll.user.first_name ? poll.user.first_name + " " + poll.user.last_name : poll.user.display_name }} -->
            </p>
            <p class="m-0 cp p-0 text-capitalize" @click="viewProfile" v-if="poll.user.role === 'admin'">
              {{ poll.user.display_name || "DoveMed Admin" }}
            </p>
            <!-- <p class="m-0 p-0 cp" @click="viewProfile" v-if="poll.user.role === 'caregiver'">
              {{ poll.user.display_name.charAt(0).toUpperCase() + poll.user.display_name.slice(1) }}'s patient
            </p> -->
            <p class="m-0 p-0 cp text-capitalize" @click="viewProfile" v-if="poll.user.role === 'doctor' || poll.user.role === 'physician' || poll.user.role === 'hcp'">
              <!-- {{ "Dr." + " " + poll.user.first_name.charAt(0).toUpperCase() + poll.user.first_name.slice(1) }}
              {{ poll.user.last_name }} -->
              {{ poll.user.deactivated ? "Anonymous User" : poll.user.display_name ? poll.user.display_name[0].toUpperCase() + poll.user.display_name.slice(1) : "Dr." }}
            </p>
            <p class="font14 p-0 fw400">
              <font-awesome-icon size="1x" :icon="['fal', 'poll']" class="mx-2" />
              created a {{ poll.content_type === "trivia" ? "trivia" : "poll" }}
            </p>
          </div>

          <!-- ROLE TAGS -->
          <div class="post-physician py-1 px-2 turquoise-text turquoise-bg font12" v-if="poll.user.role === 'admin'">DoveMed Admin</div>
          <div class="post-physician py-1 px-2 font12" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="!poll.user.deactivated && poll.user.role === 'caregiver'">
            <font-awesome-icon :icon="['far', 'hands-heart']" class="mr-1" />
            Caregiver
          </div>
          <div class="" v-if="!poll.user.deactivated && poll.user.role === 'business_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'store']" class="mr-1" />
              Business
            </span>
          </div>
          <div class="d-flex flex-wrap gap8" v-if="!poll.user.deactivated && poll.user.role === 'hospital_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'hospital-alt']" class="mr-1" />
              Hospital
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="poll.user.speciality"> {{ poll.user.speciality }} </span>
          </div>
          <div class="d-flex flex-wrap gap8" v-if="!poll.user.deactivated && poll.user.role === 'clinic_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'hospital']" class="mr-1" />
              Clinic
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="poll.user.speciality"> {{ poll.user.speciality }} </span>
          </div>
          <div class="p-0 d-flex flex-wrap gap8" v-if="!poll.user.deactivated && (poll.user.role === 'ohcp' || poll.user.role === 'hcp')">
            <span class="post-physician py-1 px-2 orange-bg orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'user-nurse']" class="mr-1" />
              Advanced Practice Provider
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="poll.user.speciality"> {{ poll.user.speciality }} </span>
          </div>
          <div class="p-0 d-flex flex-wrap gap8" v-if="!poll.user.deactivated && (poll.user.role === 'doctor' || poll.user.role === 'physician')">
            <span class="post-physician py-1 px-2 orange-bg orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
              Physician
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="poll.user.speciality"> {{ poll.user.speciality }} </span>
          </div>
          <div class="p-0 d-flex flex-wrap gap8" v-if="!poll.user.deactivated && (poll.user.role === 'nfp' || poll.user.role === 'nfp_administrator')">
            <span class="post-physician py-1 px-2 orange-bg orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'hand-holding-heart']" class="mr-1" />
              Non For Profit
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="poll.user.speciality"> {{ poll.user.speciality }} </span>
          </div>
          <div v-if="!poll.user.deactivated && poll.user.role === 'advocate'" class="d-flex my-1 flex-wrap gap8">
            <div class="post-physician py-1 px-2 font12" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }">
              <font-awesome-icon :icon="['fas', 'bullhorn']" class="mr-1" />
              Advocate
              <!-- for
              {{ currentCircle.condition_type.slice(0, 20) }}
              {{ currentCircle.condition_type.length > 20 ? "..." : "" }} -->
            </div>
            <div v-if="poll.user.organization" class="bg-purple50 purple300 rounded fw700 font12 py-1 px-2">Supporting {{ poll.user.organization }}</div>
          </div>

          <p class="posted mt-1">{{ formatPostTime(poll.post_time) }}</p>
        </div>

        <template v-if="!poll.admin_unflagged">
          <!-- menu for self -->
          <button v-if="poll.user.id === authUser.user.id && poll.user.role === authUser.user.role && poll.user_role !== 'admin'" class="threedot-menu cp">
            <div class="dot-menu-cont" @click="e => ($refs.drawerRef.isMobile ? $refs.drawerRef.show() : fetchUser(e))">
              <font-awesome-icon size="1x" class="gray400 h16" :icon="['far', 'ellipsis-v']" />
            </div>
            <div :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
              <p class="card-item show-in-mobile" @click="() => $refs.sharePostModal.show(poll, 5, 'Share Poll')">
                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2 w30">
                  <path
                    d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                    fill="black"
                  />
                </svg>
                Share
              </p>
              <p class="card-item" @click="e => handleDeletePostModal(e, poll)">
                <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2 w30" />
                Delete Poll
              </p>
            </div>
          </button>

          <!-- menu for others -->
          <button v-else class="threedot-menu cp">
            <div class="dot-menu-cont" @click="e => ($refs.drawerRef.isMobile ? $refs.drawerRef.show() : fetchUser(e))">
              <font-awesome-icon size="1x" class="gray400 h16" :icon="['far', 'ellipsis-v']" />
            </div>
            <div :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
              <p class="card-item show-in-mobile" @click="() => $refs.sharePostModal.show(poll, 5, 'Share Poll')">
                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2 w30">
                  <path
                    d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                    fill="black"
                  />
                </svg>
                Share
              </p>
              <p class="card-item" @click="savePoll">
                <font-awesome-icon size="1x" :icon="pollSaved ? ['fas', 'bookmark'] : ['fal', 'bookmark']" class="mr-2 w30" />
                Save
              </p>
              <p class="card-item" @click="showModel(poll)" v-if="!poll.admin_unflagged">
                <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 w30" />
                Report {{ poll.content_type === "trivia" ? "trivia" : "poll" }}
              </p>
              <hr class="my-0" v-if="poll.user.role !== 'admin'" />
              <p class="card-item" @click="muteUser" v-if="poll.user.role !== 'admin' && poll.user.id !== authUser.user.id">
                <font-awesome-icon size="1x" :icon="['fal', 'comment-alt-slash']" class="mr-2 w30" />
                Mute User
              </p>
              <!-- <p
              v-if="showRemoveCircleOption"
              class="card-item"
              @click="() => $refs.removeUserModal.show(poll.user)"
            >
              Remove from Circle
            </p> -->
            </div>
          </button>
        </template>
      </div>

      <p
        v-if="poll.post_text"
        :style="{ 'white-space': 'pre-wrap', 'margin-left': '-15px', overflow: 'hidden', height: seeMoreClicked ? 'auto' : '200px' }"
        class="content ql-editor post-description gray600"
        v-html="poll.post_text"
        ref="postRef"
      ></p>
      <p class="mb-0 gray400 font14 mt-3 cp" @click="() => (seeMoreClicked = true)" v-if="!seeMoreClicked">See More</p>

      <div v-if="poll.poll_attach && poll.poll_attach.length">
        <img
          :src="poll.poll_attach && poll.poll_attach[0] ? (poll.poll_attach[0].resized_images ? poll.poll_attach[0].resized_images.dov1280x720 : poll.poll_attach[0].url) : ''"
          :style="{
            width: '100%',
            height: '100%',
            'object-fit': 'contain',
            'max-height': '360px',
          }"
          :alt="poll.poll_attach[0].name || 'poll_image'"
          class="mb-3 mt-2"
        />
      </div>
      <p :style="{ 'white-space': 'pre-wrap', 'margin-left': '-15px' }" class="content ql-editor post-description gray900 fw700" v-html="poll.poll_question"></p>

      <div v-if="showPercent || poll.choices.some(i => i.my_vote === true) || (poll.user.id === authUser.user.id && poll.user.role === authUser.user.role)" class="row p-2">
        <!-- <div class="options" v-for="option in poll.choices" :key="option.id">
          <div class="option p-0" style="cursor: default">
            <div
              @click="choice = option.id"
              class="option gray900 fw700"
              v-if="option.choice_vote"
              :style="{
                background: poll.content_type === 'trivia' && option.correct ? '#00C853' : poll.content_type === 'trivia' ? '#FF9999' : lighten(getPrimaryColor(), 50),
                maxWidth: option.choice_vote + '%',
                cursor: 'default',
              }"
            />
            <span class="poll-option fw700">{{ option.poll_option }}</span>
            <span class="percentage fw700"> {{ option.choice_vote ? option.choice_vote.toFixed(0) : 0 }} % </span>
          </div>
        </div> -->

        <div
          class="w-100 mb-3"
          v-for="option in poll.choices"
          :key="option.id"
          :style="{
            background: '#f1f5f9',
            padding: '16px',
            position: 'relative',
            'border-radius': '10px',
            overflow: 'hidden',
          }"
          @click="choice = option.id"
        >
          <div
            :style="{
              position: 'absolute',
              width: option.choice_vote + '%',
              background: poll.content_type === 'trivia' && option.correct ? '#00C853' : poll.content_type === 'trivia' ? '#FF9999' : lighten(getPrimaryColor(), 50),
              height: '100%',
              top: 0,
              left: 0,
              'z-index': 1,
            }"
            v-if="option.choice_vote"
          ></div>
          <div
            :style="{
              'z-index': 2,
              position: 'relative',
              display: 'flex',
              'align-items': 'center',
              gap: '24px',
              'justify-content': 'space-between',
            }"
          >
            <p class="fw700">{{ option.poll_option }}</p>
            <p class="fw700" :style="{ 'min-width': '44px' }">{{ option.choice_vote ? option.choice_vote.toFixed(0) : 0 }} %</p>
          </div>
        </div>

        <div v-if="poll.user.id !== authUser.user.id || poll.user.role !== authUser.user.role" class="d-flex justify-content-between w-100">
          <p :style="{ color: getPrimaryColor() }">Thank you for your Answer</p>
          <p>Total Votes : {{ poll.total_vote }}</p>
        </div>
        <p v-if="poll.user.id === authUser.user.id && poll.user.role === authUser.user.role" class="poll-attempts">This poll has been taken {{ poll.no_of_attempts }} times.</p>
      </div>

      <div v-else class="row p-2">
        <div class="options" v-for="option in poll.choices" :key="option.id">
          <div
            @click="handleSubmitChoice(option.id)"
            :style="{
              background: choice === option.id ? getPrimaryColor() : '',
              color: choice === option.id ? 'white !important' : '',
            }"
            class="option gray900 fw700"
          >
            {{ option.poll_option }}
          </div>
        </div>
      </div>

      <div v-if="poll.tags && poll.tags.length" class="post__tags mb-4">
        <div
          v-for="(tag, index) in poll.tags.slice(0, 3)"
          :key="index"
          class="tags rounded"
          :style="{
            color: getPrimaryColor(),
            background: getPrimary50Color(),
          }"
        >
          #{{ tag }}
        </div>
        <div v-if="poll.tags.length > 3" class="popover-button">
          <a-popover placement="right">
            <template slot="content">
              <p
                v-for="(tag, index) in poll.tags.slice(3)"
                :key="index"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                class="rounded p-1"
              >
                #{{ tag }}
              </p>
            </template>
            <a-button
              :style="{
                background: getPrimary50Color(),
                color: getPrimaryColor(),
                'font-size': '10px',
                'line-height': '20px',
              }"
              class="rounded"
            >
              +{{ poll.tags.length - 3 }}
            </a-button>
          </a-popover>
        </div>
      </div>
      <!-- <p class="posted mb-3">Posted {{ formatPostTime(poll.post_time) }}</p> -->
      <div class="d-flex like-comment-gap mt-2">
        <!-- <div id="hugs" class="u-options" @click="react(poll, $event)">
          <font-awesome-icon
            size="1x"
            :icon="
              reactions.hugs ? ['fas', 'hands-heart'] : ['fal', 'hands-heart']
            "
            :style="{ color: reactions.hugs ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">
            Embrace ({{ poll.reaction.hugs }})
          </div>
        </div> -->

        <!-- LIKES -->
        <!-- <div id="likes" class="u-options showReactions" @click="react(poll, $event)"> -->
        <div id="likes" class="u-options showReactions">
          <!-- <font-awesome-icon
            size="1x"
            :icon="reactions.likes ? ['fas', 'heart'] : ['fal', 'heart']"
            :style="{
              color: reactions.likes ? getPrimaryColor() : '',
              height: '20px',
              width: '17.5px',poll
              'margin-right': '1px',
            }"
          /> -->
          <font-awesome-icon
            v-if="!currentClickedReaction"
            :icon="['fal', 'heart']"
            :style="{
              height: '20px',
              width: '17.5px',
              'margin-right': '1px',
            }"
          />
          <img v-else :src="require(`../../../assets/emojis/${currentClickedReaction}-40.png`)" class="hw20" alt="emoji" :style="{ transform: 'translateY(-1.5px)' }" />
          <div class="posted-reactions-text like-text">
            <!-- Like -->
            {{ currentClickedReaction || "Like" }}
            <!-- Like ({{ poll.reaction.likes }}) -->
          </div>

          <!-- emoji reactions on hover -->
          <div class="emojiReactions" v-if="showReactionsHover">
            <emoji-reactions :handleClick="handleReactionsClick" />
          </div>
        </div>

        <div
          class="u-options"
          :style="{
            cursor: 'default',
            display: !poll.allow_comments ? 'none' : 'flex',
          }"
        >
          <!-- @click="comments.length === 0 && fetchPollComments()" -->
          <font-awesome-icon size="1x" :icon="['fal', 'comment-alt']" :style="{ height: '20px' }" />
          <div class="posted-reactions-text like-text show-in-mobile">
            {{ pagination.total_count || 0 }}
          </div>
          <div class="posted-reactions-text hide-comment">
            {{ pagination.total_count || 0 }}
            {{ pagination.total_count > 1 ? "Comments" : "Comment" }}
            <!-- Comment ({{ poll.comments_count }}) -->
          </div>
        </div>
        <!-- <div id="favorites" class="u-options" @click="react(poll, $event)">
          <font-awesome-icon
            size="1x"
            :icon="
              reactions.favorites ? ['fas', 'bookmark'] : ['fal', 'bookmark']
            "
            :style="{ color: reactions.favorites ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">Bookmark</div>
        </div> -->
        <div class="u-options hide-in-mobile" @click="() => $refs.sharePostModal.show(poll, 5, 'Share Poll')">
          <!-- <font-awesome-icon size="1x" :icon="['fal', 'share-alt']" /> -->
          <!-- <img
            src="../../../assets/images/share.png"
            :style="{ width: '20px', height: '15px' }"
            alt="share"
          /> -->
          <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom: 2px">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            />
          </svg>
          <div class="posted-reactions-text">Share</div>
        </div>

        <div class="u-options ml-auto m-pl-30 m-ml-0 d-flex flex-row-reverse" @click="() => $refs.Reactions.show()">
          <!-- <font-awesome-icon
            size="1x"
            :icon="['fas', 'heart-circle']"
            :style="{ color: '#EA3100', transform: 'scale(1.25)' }"
            class=""
          />
          <div class="posted-reactions-text like-text">
            {{ poll.reaction.likes }}
          </div> -->
          <span class="ml-2">
            {{ getTotalReactions() }}
          </span>
          <img v-for="emoji in getTopThreeReactions()" :key="emoji" :src="require(`../../../assets/emojis/${emoji}-40.png`)" alt="emoji" class="hw20" />
          <reactions ref="Reactions" :postProp="poll" :key="posting" />
        </div>
      </div>

      <hr class="mt-3" v-if="poll.allow_comments" />
      <div v-if="comments.length || poll.allow_comments" :style="{ margin: '0 -20px', padding: '0 20px' }">
        <span
          v-if="comments.length < pagination.total_count"
          :style="{
            color: getPrimaryColor(),
            display: 'block',
            cursor: 'pointer',
            'font-size': '14px',
            'margin-top': '16px',
            'margin-bottom': '16px',
          }"
          @click="fetchPollComments(true)"
        >
          See {{ pagination.total_count - comments.length }} previous
          {{ pagination.total_count - comments.length === 1 ? "comment" : "comments" }}
        </span>
        <div v-for="comment in getReversedComments" :key="comment.id">
          <!-- <div v-for="comment in comments" :key="comment.id"> -->
          <Comment :commentData="comment" :removeCommentFromDisplay="removeCommentFromDisplay" :setLoadingScreen="setLoadingScreen" />
        </div>
      </div>

      <div v-if="isImageUploading" class="d-flex justify-content-center mt-2">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">Loading image...</div>
      </div>
      <div v-if="fileList.length > 0" class="image-uploading">
        <!-- Image Upload -->
        <a-upload v-if="fileList.length > 0" listType="picture-card" class="position-relative avatar-uploader" :fileList="fileList" @preview="handlePreview" @change="handleChange"></a-upload>
        <a-modal wrap-class-name="preview-modal" :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img style="width: 100%" :src="previewImage" alt="image" />
        </a-modal>
      </div>

      <!-- <div class="d-flex" v-if="poll.allow_comments">
        <div v-if="showWritable" class="post-comment align-items-center" style="display: flex; justify-content: space-between; width: 100%">
          <div class="title d-flex align-items-center mr-2">
            <a-avatar
              :style="{
                color: ' #ffffff !important',
                'background-color': authUser.user.url ? '' : getAvatarColor(authUser.user.id),
              }"
              :src="authUser.user.url"
              class="text-capitalize comment-avatar"
              :size="40"
            >
              {{ getAuthUserInitials() }}
            </a-avatar>
          </div>
          <a-input placeholder="Comment on Poll..." v-model="comment" @keyup.enter="postComment()" class="commentText" :disabled="!poll.allow_comments" />
          <font-awesome-icon
            size="1x"
            class="position-absolute cp cam-inp-right"
            :style="{
              top: '2px',
              transform: 'scale(0.6)',
            }"
            :icon="['fal', 'camera']"
          />
          <input class="camera-icon-inp cp cam-inp-right" type="file" ref="fileInput" @change="handlePicUpload()" />
          <span
            class="position-absolute"
            :style="{
              display: 'flex',
              'align-self': 'center',
              'z-index': '10',
              right: '16px',
              top: '3px',
            }"
          >
            <span class="cp" :style="{ transform: 'scale(0.75)' }" ref="BlackEmojiPicker">
              <BlackEmojiPicker :visible="emojiVisible" :handleVisible="handleEmojiVisible" :insert="insert" />
            </span>
            <span class="my-auto cp font14 fw700 hide-in-mobile" :style="{ color: getPrimaryColor(), 'margin-left': '8px' }" @click="postComment()"> Comment </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              class="my-auto cp font14 show-in-mobile fw700 h18"
              :style="{ fill: getPrimaryColor(), 'margin-left': '8px' }"
              @click="postComment()"
            >
              <path
                d="M81.9 27.8C47.1 12.7 12.8 50.1 30.8 83.5l69.3 128.8c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L30.8 428.5c-18 33.4 16.3 70.8 51.1 55.7L523.8 292.7c32.1-13.9 32.1-59.5 0-73.4L81.9 27.8z"
              />
            </svg>
          </span>
        </div>
      </div> -->

      <div class="d-flex align-items-center" v-if="poll.allow_comments && showWritable" :style="{ padding: '20px', margin: '0 -20px -20px', background: '#FFF' }">
        <a-avatar
          :style="{ 'background-color': authUser.user.url ? '' : getAvatarColor(authUser.user.id) }"
          :src="authUser.user.url"
          class="text-capitalize comment-avatar font-white fw700"
          :size="40"
          alt="avatar"
        >
          {{ getAuthUserInitials() }}
        </a-avatar>
        <div class="d-flex align-items-center bg-gray50 flex-grow-1 ml-2 comment-container">
          <a-textarea placeholder="Add a comment..." v-model="comment" class="commentText comment-textarea mr-3" auto-size @keyup="handleKeyUp" />
          <div class="camera position-relative cp">
            <font-awesome-icon class="hw20" :icon="['fal', 'camera']" />
            <input class="position-absolute camera-icon-inp hw20" type="file" accept="image/png, image/jpeg, image/gif, image/svg+xml" ref="fileInput" @change="handlePicUpload()" />
          </div>
          <BlackEmojiPicker :visible="emojiVisible" :handleVisible="handleEmojiVisible" :insert="insert" class="cp emoji" />
          <div class="cp font14 fw700 hide-in-mobile mr-3 text" :style="{ color: getPrimaryColor() }" @click="postComment()">Comment</div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="cp font14 show-in-mobile fw700 h40 icon" :style="{ fill: getPrimaryColor() }" @click="postComment()">
            <path
              d="M81.9 27.8C47.1 12.7 12.8 50.1 30.8 83.5l69.3 128.8c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L30.8 428.5c-18 33.4 16.3 70.8 51.1 55.7L523.8 292.7c32.1-13.9 32.1-59.5 0-73.4L81.9 27.8z"
            />
          </svg>
        </div>
      </div>
    </div>

    <ReportContentModal ref="reportContentModal" />
    <RemoveUserModal ref="removeUserModal" v-on:hideDots="displayDots = false" />
    <DeletePostModal ref="deletePostModal" />
    <SharePostModal ref="sharePostModal" />
    <DrawerModal ref="drawerRef">
      <div v-if="poll.user.id === authUser.user.id && poll.user.role === authUser.user.role && poll.user_role !== 'admin'" @click="$refs.drawerRef.close()">
        <p class="drawer-item" @click="() => $refs.sharePostModal.show(poll, 5, 'Share Poll')">
          <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2 w30">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            />
          </svg>
          Share
        </p>
        <p class="drawer-item" @click="e => handleDeletePostModal(e, poll)">
          <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2 w30" />
          Delete Poll
        </p>
      </div>
      <div v-else @click="$refs.drawerRef.close()">
        <p class="drawer-item" @click="() => $refs.sharePostModal.show(poll, 5, 'Share Poll')">
          <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2 w30">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            />
          </svg>
          Share
        </p>
        <p class="drawer-item" @click="savePoll">
          <font-awesome-icon size="1x" :icon="pollSaved ? ['fas', 'bookmark'] : ['fal', 'bookmark']" class="mr-2 w30" />
          Save
        </p>
        <p class="drawer-item" @click="showModel(poll)" v-if="!poll.admin_unflagged">
          <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 w30" />
          Report {{ poll.content_type === "trivia" ? "trivia" : "poll" }}
        </p>
        <hr class="my-0" v-if="poll.user.role !== 'admin'" />
        <p class="drawer-item" @click="muteUser" v-if="poll.user.role !== 'admin' && poll.user.id !== authUser.user.id">
          <font-awesome-icon size="1x" :icon="['fal', 'comment-alt-slash']" class="mr-2 w30" />
          Mute User
        </p>
      </div>
    </DrawerModal>
    <div v-if="loadingScreen || posting" class="spinnerContainer-post">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import ReportContentModal from "../../Modals/ReportContent.vue"
import RemoveUserModal from "../../Modals/RemoveUser"
import SharePostModal from "../../Modals/SharePost"
import Comment from "./UserPollComment.vue"
import s3Upload from "../../../utilities/imageUploader"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import { eventBus } from "../../../main"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faCamera, faPoll, faPen, faTrash } from "@fortawesome/pro-light-svg-icons"
import { faBullhorn } from "@fortawesome/pro-solid-svg-icons"
import { faHandsHeart, faHospitalAlt, faHandHoldingHeart } from "@fortawesome/pro-regular-svg-icons"
import DeletePostModal from "../../Modals/deletePostModal.vue"
import BlackEmojiPicker from "../BlackEmojiPicker.vue"
import Reactions from "../../Modals/activity/Reactions.vue"
import EmojiReactions from "../../commons/EmojiReactions.vue"
import DrawerModal from "../../Modals/DrawerModal.vue"

library.add(faBullhorn, faCamera, faPoll, faPen, faTrash, faHandHoldingHeart, faHandsHeart, faHospitalAlt)

const UserRepository = RepositoryFactory.get("user")
const ResourceRepository = RepositoryFactory.get("resource")
const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "UserPollCard",
  components: {
    ReportContentModal,
    RemoveUserModal,
    SharePostModal,
    Comment,
    DeletePostModal,
    BlackEmojiPicker,
    EmojiReactions,
    Reactions,
    DrawerModal,
  },
  props: {
    fetchPosts: { type: Function, default: () => {} },
    pollData: Object,
    fromProfilePolls: Boolean,
    fromShare: Boolean,
    fromProfileSaved: Boolean,
    commentId: Number,
  },
  computed: {
    getReversedComments() {
      return this.comments.toReversed()
    },
    getPollUserInitials() {
      // let f = "",
      //   l = ""
      // if (this.poll.user.role === "physician" || this.poll.user.role === "doctor" || this.poll.user.role === "hcp") {
      //   f = this.poll.user.first_name ? this.poll.user.first_name[0] : "D"
      //   l = this.poll.user.last_name ? this.poll.user.last_name[0] : ""
      // }
      // if (this.poll.user.role === "advocate") {
      //   f = this.poll.user.display_name.split(" ")[0][0] || "A"
      //   l = this.poll.user.display_name.split(" ").slice(1).join(" ")?this.poll.user.display_name.split(" ").slice(1).join(" ")[0] : ""
      // } else {
      //   f = this.poll.user.display_name ? this.poll.user.display_name[0] : "D"
      //   l = this.poll.user.display_name.split(" ").slice(1).join(" ") ? this.poll.user.display_name.split(" ").slice(1).join(" ")[0] : ""
      // }
      const f = this.poll.user.display_name ? this.poll.user.display_name[0] : "D"
      const l = this.poll.user.display_name
        .split(" ")
        .slice(1)
        .join(" ")
        ? this.poll.user.display_name
            .split(" ")
            .slice(1)
            .join(" ")[0]
        : ""
      return f.toUpperCase() + l.toUpperCase()
    },
  },
  created() {
    window.addEventListener("mouseup", e => {
      if (this.displayDots) {
        setTimeout(() => {
          this.displayDots = false
        }, 100)
      }
      if (e.target.className === "emoji-picker") {
        return
      }
      if (this.emojiVisible) {
        setTimeout(() => {
          this.emojiVisible = false
        }, 100)
      }
    })
    this.poll = this.pollData
    console.log(this.poll.poll_question, "-> user poll ->", this.poll)
    // console.log("comments ->", this.comments);
    // console.log("comments.length ->", this.comments.length);
    // console.log("pagination ->", this.pagination);
    this.getAllReactions()
    // console.log("(created) - poll reactions ->", this.reactions)
    this.poll.my_reaction.forEach(r => {
      r.reaction_type === 4 && (this.pollSaved = true)
    })
    this.poll.comments_count && this.fetchPollComments()

    const MIRROR_REACTION_TYPES = {
      1: "embrace",
      2: "like",
      8: "happy",
      9: "emotional",
      10: "angry",
    }
    const reaction_ids = [1, 2, 8, 9, 10]
    const oldReact = this.poll.my_reaction.find(eachR => reaction_ids.includes(eachR.reaction_type))
    this.currentClickedReaction = this.poll.my_reaction.length && oldReact ? MIRROR_REACTION_TYPES[oldReact.reaction_type] : null
  },

  mounted() {
    if (this.poll.post_text) {
      if (this.poll.post_text.length <= 200 || this.$el.querySelector(".ql-editor").scrollHeight <= 200) {
        this.seeMoreClicked = true
      }
    } else {
      this.seeMoreClicked = true
    }
  },

  filters: {
    updatedAt(date) {
      return moment(date).format("DD/MM/YYYY")
    },
  },

  data() {
    return {
      seeMoreClicked: false,
      showReactionsHover: true,
      currentClickedReaction: null,
      showWritable: true,
      showRemoveCircleOption: true,
      isImageUploading: false,
      choice: null,
      poll: {},
      showPercent: false,
      reactions: {
        hugs: false,
        likes: false,
        favorites: false,
        happy: false,
        sad: false,
        angry: false,
      },
      posting: false,
      comments: [],
      comment_attach: [],
      comment: "",
      fileList: [],
      previewImage: false,
      previewVisible: false,
      pagination: { total_count: 0 },
      currentPage: 1,
      displayDots: false,
      emojiVisible: false,
      loadingScreen: false,
      pollSaved: undefined,
      notificationCommentCalled: false,
    }
  },

  methods: {
    handleKeyUp(e) {
      if (e.shiftKey) {
        return
      } else if (e.key === "Enter") {
        e.preventDefault()
        this.postComment()
      }
    },
    getAllReactions() {
      this.reactions.hugs = !!this.getReaction(1).length
      this.reactions.likes = !!this.getReaction(2).length
      // this.reactions.favorites = !!this.getReaction(4).length;
      this.reactions.happy = !!this.getReaction(8).length
      this.reactions.sad = !!this.getReaction(9).length
      this.reactions.angry = !!this.getReaction(10).length
    },
    getTopThreeReactions() {
      // console.log(this.poll.reaction);
      // const sortedReactions = Object.keys(this.poll.reaction).sort(
      //   (a, b) => this.poll.reaction[a] - this.poll.reaction[b]
      // );
      // console.log(sortedReactions.slice(0, 3));
      return ["happy", "embrace", "like"]
    },
    getTotalReactions() {
      // console.log("getTotalReactions -> poll.reaction ->", this.poll.reaction);
      let value = 0
      const reacts = ["angry", "sad", "happy", "likes", "hugs"]
      reacts.forEach(key => (value = value + this.poll.reaction[key]))
      return value || 0
    },
    handleReactionsClick(emoji) {
      // const MIRROR_REACTION_TYPES = {
      //   1: "hugs",
      //   2: "likes",
      //   4: "favorites",
      //   8: "happy",
      //   9: "sad",
      //   10: "angry",
      // }
      const REACTION_TYPES = {
        HUGS: 1,
        HUG: 1,
        EMBRACE: 1,
        LIKE: 2,
        LIKES: 2,
        USEFUL: 3,
        FAVORITE: 4,
        BOOKMARK: 4,
        FLAGED: 5,
        FLAGGED: 5,
        FLAG: 5,
        REPORT: 5,
        HAPPY: 8,
        HAHA: 8,
        SAD: 9,
        EMOTIONAL: 9,
        ANGRY: 10,
        MAD: 10,
      }

      // console.log("clicked ->", emoji)
      // console.log("1 - current ->", this.currentClickedReaction)

      if (this.currentClickedReaction !== emoji) {
        this.currentClickedReaction = emoji
      } else {
        this.currentClickedReaction = null
      }
      setTimeout(() => {
        this.showReactionsHover = false
      }, 50)
      setTimeout(() => {
        this.showReactionsHover = true
      }, 100)

      // console.log("2 - current ->", this.currentClickedReaction)

      if (!this.currentClickedReaction) {
        // delete current reaction
        // console.log("ONLY deleting current reaction")
        this.react({ id: this.poll.id }, "", false, emoji)
        return
      }

      if (this.pollSaved ? this.poll.my_reaction.length > 1 : this.poll.my_reaction.length) {
        // console.log("saving reaction by overwriting")

        this.posting = true
        const headers = { Authorization: `Bearer ${this.authUser.user.token}` }

        // TODO

        // 1 get old reaction
        // this.$http
        //   .get(
        //     `${process.env.BASE_API_URL}/reactions/?reacted_on_id=${this.poll.id}&circle_id=${this.currentCircle.id}&user_id=${this.authUser.user.id}`,
        //     { headers }
        //   )
        //   .then(res1 => {
        //     console.log("1 -> get - response ->", res1.data.data[0])

        const reaction_ids = [1, 2, 8, 9, 10]
        const oldReact = this.poll.my_reaction.find(eachR => reaction_ids.includes(eachR.reaction_type))
        // const oldReactionName = MIRROR_REACTION_TYPES[oldReact.reaction_type]
        const oldReactionId = oldReact.id
        const newReactionName = emoji
        const newReactionId = REACTION_TYPES[newReactionName.toUpperCase()]

        // 2 delete old reaction
        this.$http
          .delete(`${process.env.BASE_API_URL}/reactions/?ids=${oldReactionId}`, {
            headers,
          })
          .then(res => {
            // this.reactions[MIRROR_REACTION_TYPES[REACTION_TYPES[oldReactionName.toUpperCase()]]] = false
            // this.poll.reaction[MIRROR_REACTION_TYPES[REACTION_TYPES[oldReactionName.toUpperCase()]]] -= 1

            // console.log("1 -> deleted reaction")

            // console.log("newReactionName ->", newReactionName)
            // console.log("newReactionId ->", newReactionId)

            // 3 save new reaction
            PostRepository.saveReaction(this.currentCircle.id, {
              reacted_on_type: 5,
              reacted_on_id: this.poll.id,
              user: this.authUser.user.id,
              reaction_type: newReactionId,
            })
              .then(res2 => {
                if (this.fromProfilePolls) {
                  console.warn("fromProfilePolls")

                  this.$http
                    .get(`${process.env.BASE_API_URL}/polls/?id=${this.poll.id}&circle_id=${this.currentCircle.id}&page_num=1&items=1`, { headers })
                    .then(res100 => {
                      console.log("res100.data.data.data:", res100.data.data.data)
                    })
                    .catch(e => {
                      console.log("error api check")
                    })

                  this.$http
                    .get(`${process.env.BASE_API_URL}/polls/?id=${this.poll.postId}&circle_id=${this.currentCircle.id}&page_num=1&items=1`, { headers })
                    .then(res3 => {
                      this.poll.hugs_reacted_users = res3.data.data.data[0] ? res3.data.data.data[0].hugs_reacted_users : res3.data.data.data[0].hugs_reacted_users
                      this.poll.happy_reacted_users = res3.data.data.data[0] ? res3.data.data.data[0].happy_reacted_users : res3.data.data.data[0].happy_reacted_users
                      this.poll.sad_reacted_users = res3.data.data.data[0] ? res3.data.data.data[0].sad_reacted_users : res3.data.data.data[0].sad_reacted_users
                      this.poll.likes_reacted_users = res3.data.data.data[0] ? res3.data.data.data[0].likes_reacted_users : res3.data.data.data[0].likes_reacted_users
                      this.poll.angry_reacted_users = res3.data.data.data[0] ? res3.data.data.data[0].angry_reacted_users : res3.data.data.data[0].angry_reacted_users
                      this.poll.my_reaction = res3.data.data.data[0] ? res3.data.data.data[0].my_reaction : res3.data.data.data[0].my_reaction
                      this.poll.reaction = res3.data.data.data[0] ? res3.data.data.data[0].reaction : res3.data.data.data[0].reaction
                      this.getAllReactions()
                      this.posting = false
                    })
                    .catch(err => {
                      this.$notification.error({ message: "Error - R1", description: "Updated reacted users cannot be fetched" })
                      this.posting = false
                    })
                } else if (this.fromProfileSaved) {
                  console.warn("fromProfileSaved")

                  this.$http
                    .get(`${process.env.BASE_API_URL}/polls/?id=${this.poll.id}&circle_id=${this.currentCircle.id}&page_num=1&items=1`, { headers })
                    .then(res100 => {
                      console.log("res100.data.data.data:", res100.data.data.data)
                    })
                    .catch(e => {
                      console.log("error api check")
                    })

                  this.$http
                    .get(
                      `${process.env.BASE_API_URL}/reactionsfavoritelist/?user=${this.authUser.user.id}&reacted_on_id=${this.poll.postId}&circle_id=${this.currentCircle.id}&reacted_on_type=5&role=${this.authUser.user.role}&page_num=1&items=1`,
                      { headers }
                    )
                    .then(res2 => {
                      this.poll.hugs_reacted_users = res2.data.data.data[0].favorite[0].hugs_reacted_users
                      this.poll.happy_reacted_users = res2.data.data.data[0].favorite[0].happy_reacted_users
                      this.poll.sad_reacted_users = res2.data.data.data[0].favorite[0].sad_reacted_users
                      this.poll.likes_reacted_users = res2.data.data.data[0].favorite[0].likes_reacted_users
                      this.poll.angry_reacted_users = res2.data.data.data[0].favorite[0].angry_reacted_users
                      this.poll.my_reaction = res2.data.data.data[0].favorite[0].my_reaction
                      this.poll.reaction = res2.data.data.data[0].favorite[0].reaction
                      this.getAllReactions()
                      this.posting = false
                    })
                    .catch(err => {
                      this.$notification.error({ message: "Error - R2", description: "Updated reacted users cannot be fetched saved part" })
                      this.posting = false
                    })
                } else {
                  console.warn("ELSE")
                  this.$http
                    .get(`${process.env.BASE_API_URL}/dovemedpost/?id=${this.poll.postId}&circle_id=${this.currentCircle.id}&page_num=1&items=1`, { headers })
                    .then(res3 => {
                      this.poll.hugs_reacted_users = res3.data.data.data[0].user_poll ? res3.data.data.data[0].user_poll.hugs_reacted_users : res3.data.data.data[0].hugs_reacted_users
                      this.poll.happy_reacted_users = res3.data.data.data[0].user_poll ? res3.data.data.data[0].user_poll.happy_reacted_users : res3.data.data.data[0].happy_reacted_users
                      this.poll.sad_reacted_users = res3.data.data.data[0].user_poll ? res3.data.data.data[0].user_poll.sad_reacted_users : res3.data.data.data[0].sad_reacted_users
                      this.poll.likes_reacted_users = res3.data.data.data[0].user_poll ? res3.data.data.data[0].user_poll.likes_reacted_users : res3.data.data.data[0].likes_reacted_users
                      this.poll.angry_reacted_users = res3.data.data.data[0].user_poll ? res3.data.data.data[0].user_poll.angry_reacted_users : res3.data.data.data[0].angry_reacted_users
                      this.poll.my_reaction = res3.data.data.data[0].user_poll ? res3.data.data.data[0].user_poll.my_reaction : res3.data.data.data[0].my_reaction
                      this.poll.reaction = res3.data.data.data[0].user_poll ? res3.data.data.data[0].user_poll.reaction : res3.data.data.data[0].reaction
                      this.getAllReactions()
                      this.posting = false
                    })
                    .catch(err => {
                      this.$notification.error({ message: "Error - R3", description: "Updated reacted users cannot be fetched" })
                      this.posting = false
                    })
                }
              })
              .catch(err => {
                this.$notification.error({ message: "Error", description: "New reaction could not be saved" })
                this.posting = false
              })
          })
          .catch(err => {
            this.$notification.error({ message: "Error", description: "Existing reaction could not be deleted" })
            this.posting = false
          })
        // })
        // .catch(err => {
        //   this.posting = false
        //   this.$notification.error({
        //     message: "Error",
        //     description: "Existing reaction could not be fetched",
        //   })
        // })
      } else {
        // TODO
        // save reaction
        this.react({ id: this.poll.id }, "", false, emoji)
      }
    },
    setLoadingScreen(s) {
      this.loadingScreen = s
    },
    removeCommentFromDisplay(cid, reply = false) {
      // console.log("removeCommentFromDisplay called")
      if (reply) {
        this.currentPage = 1
        this.fetchPollComments()
      } else {
        this.comments = this.comments.filter(c => c.id !== cid)
        this.pagination.total_count -= 1
      }
    },
    handleEmojiVisible() {
      this.emojiVisible = !this.emojiVisible
    },
    insert(emoji) {
      this.comment += emoji
    },
    handleDeletePostModal(e, post) {
      e.preventDefault()
      this.displayDots = false
      if (this.fromProfilePolls) {
        console.log("inside if in pollcard")
        this.$refs.deletePostModal.show(post, this.fromProfilePolls)
      }
      this.$refs.deletePostModal.show(post)
    },
    handleCloseAll() {
      this.displayDots = false
    },
    showModel(post) {
      this.$refs.reportContentModal.show(post, 5)
      this.displayDots = false
    },
    commentFunction() {
      // console.log("Poll -> commentFunction()");
      if (this.loadingScreen) {
        return
      }
      this.loadingScreen = true
      const payload = {
        poll_parent_id: this.poll.id,
        comment_text: this.comment,
        user: this.authUser.user.id,
        comment_attach: this.comment_attach.length ? this.comment_attach : null,
        commented_on_type: 5,
        commented_on_id: this.poll.id,
      }
      if (this.comment.length > 0 || this.comment_attach.length > 0) {
        PostRepository.postComment(payload, this.currentCircle.id)
          .then(res => {
            this.comments = []
            this.currentPage = 1
            this.comment = ""
            this.fetchPollComments()
            // this.poll.comments_count += 1;
            this.pagination.total_count = parseInt(this.pagination.total_count) + 1
            this.comment_attach = []
            this.emojiVisible = false
            this.$refs.fileInput.value = ""
            this.fileList = []
            this.previewImage = false
            this.previewVisible = false
          })
          .catch(err => {
            this.loadingScreen = false
          })
      }
    },
    postComment() {
      if (this.comment.trim().length || this.comment_attach.length > 0) {
        this.commentFunction()
      }
    },
    getReaction(type) {
      let status = []
      // console.log(
      //   "this.poll.my_reaction.length ->",
      //   this.poll.my_reaction.length
      // );
      if (this.poll.my_reaction && this.poll.my_reaction.length > 0) {
        status = this.poll.my_reaction.filter(reaction => {
          return reaction.reaction_type === type
        })
      }
      return status
    },
    fetchUser() {
      // console.log("inside fetchUser");
      if (this.displayDots) {
        this.displayDots = false
      } else {
        // this.displayDots = true;
        // this.loadingScreen = true;
        setTimeout(() => {
          // this.loadingScreen = false;
          this.displayDots = true
        }, 50)
        // const user = this.poll.user;
        // UserRepository.getOtherUserProfile(user, this.currentCircle.id).then(
        //   (res) => {
        //     const onCircle = res.data.data.on_circle;
        //     this.loadingScreen = false;
        //     if (!onCircle) {
        //       this.displayDots = !this.displayDots;
        //       this.showRemoveCircleOption = false;
        //     } else {
        //       this.displayDots = !this.displayDots;
        //     }
        //   }
        // );
      }
    },
    react(entity, event, comment = false, reactionType) {
      // if (this.poll.user.id === this.authUser.user.id) {
      //   return
      // }
      console.log({ reactionType })

      if (this.posting) {
        return
      }
      /**
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
       */
      // let path = event.path || (event.composedPath && event.composedPath())

      const REACTION_TYPES = {
        HUGS: 1,
        LIKE: 2,
        USEFUL: 3,
        FAVORITE: 4,
        FLAGED: 5,
        HAPPY: 8,
        HAHA: 8,
        SAD: 9,
        ANGRY: 10,
      }

      const REACTION_ON = {
        POST: 1,
        COMMENT: 2,
        QUESTION: 3,
        ARTICLE: 4,
        POLL: 5,
      }

      // const type = event.target.id ? event.target.id : path[1]["id"]
      const type = reactionType

      switch (type) {
        // case "hugs":
        //   this.reactions.hugs
        //     ? this.deleteReaction(REACTION_TYPES.HUGS, type)
        //     : this.saveReaction(
        //         entity.id,
        //         REACTION_TYPES.HUGS,
        //         comment ? REACTION_ON.COMMENT : REACTION_ON.POLL
        //       );
        //   break;
        // case "favorites":
        //   this.reactions.favorites
        //     ? this.deleteReaction(REACTION_TYPES.FAVORITE, type)
        //     : this.saveReaction(
        //         entity.id,
        //         REACTION_TYPES.FAVORITE,
        //         comment ? REACTION_ON.COMMENT : REACTION_ON.POLL
        //       );
        //   break;
        // case "flag":
        //   this.reactions.flag
        //     ? this.deleteReaction(REACTION_TYPES.FLAGED, type)
        //     : this.saveReaction(
        //         entity.id,
        //         REACTION_TYPES.FLAGED,
        //         comment ? REACTION_ON.COMMENT : REACTION_ON.POLL
        //       );
        //   break;
        case "likes":
        case "like":
          this.reactions.likes ? this.deleteReaction(REACTION_TYPES.LIKE, "likes") : this.saveReaction(entity.id, REACTION_TYPES.LIKE, comment ? REACTION_ON.COMMENT : REACTION_ON.POLL)
          break
        case "hugs":
        case "hug":
        case "embrace":
          this.reactions.hugs ? this.deleteReaction(REACTION_TYPES.HUGS, "hugs") : this.saveReaction(entity.id, REACTION_TYPES.HUGS, comment ? REACTION_ON.COMMENT : REACTION_ON.POLL)
          break
        case "angry":
        case "mad":
          this.reactions.angry ? this.deleteReaction(REACTION_TYPES.ANGRY, "angry") : this.saveReaction(entity.id, REACTION_TYPES.ANGRY, comment ? REACTION_ON.COMMENT : REACTION_ON.POLL)
          break
        case "haha":
        case "happy":
          this.reactions.happy ? this.deleteReaction(REACTION_TYPES.HAHA, "happy") : this.saveReaction(entity.id, REACTION_TYPES.HAHA, comment ? REACTION_ON.COMMENT : REACTION_ON.POLL)
          break
        case "sad":
        case "emotional":
          this.reactions.sad ? this.deleteReaction(REACTION_TYPES.EMOTIONAL, "sad") : this.saveReaction(entity.id, REACTION_TYPES.EMOTIONAL, comment ? REACTION_ON.COMMENT : REACTION_ON.POLL)
          break
        default:
          break
      }
    },
    saveReaction(postId, reactionType, reactionOnType) {
      const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
      const MIRROR_REACTION_TYPES = {
        1: "hugs",
        2: "likes",
        4: "favorites",
        8: "happy",
        9: "sad",
        10: "angry",
      }
      this.posting = true
      const payload = {
        reacted_on_type: reactionOnType,
        reacted_on_id: postId,
        user: this.authUser.user.id,
        reaction_type: reactionType,
      }

      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then(res => {
          // console.log("reaction saved ->", res.data)
          // this.posting = false
          // this.reactions[MIRROR_REACTION_TYPES[reactionType]] = true
          // this.poll.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1
          // const index = this.poll.my_reaction.findIndex(rs => rs.reaction_type === reactionType)
          // if (index >= 0) {
          //   this.poll.my_reaction.splice(index, 1)
          // }
          // this.poll.my_reaction.push(res.data.data)

          if (this.fromProfilePolls) {
            console.warn("fromProfilePolls")
            this.$http
              .get(`${process.env.BASE_API_URL}/polls/?id=${this.poll.postId}&circle_id=${this.currentCircle.id}&page_num=1&items=1`, { headers })
              .then(res2 => {
                this.poll.hugs_reacted_users = res2.data.data.data[0] ? res2.data.data.data[0].hugs_reacted_users : res2.data.data.data[0].hugs_reacted_users
                this.poll.happy_reacted_users = res2.data.data.data[0] ? res2.data.data.data[0].happy_reacted_users : res2.data.data.data[0].happy_reacted_users
                this.poll.sad_reacted_users = res2.data.data.data[0] ? res2.data.data.data[0].sad_reacted_users : res2.data.data.data[0].sad_reacted_users
                this.poll.likes_reacted_users = res2.data.data.data[0] ? res2.data.data.data[0].likes_reacted_users : res2.data.data.data[0].likes_reacted_users
                this.poll.angry_reacted_users = res2.data.data.data[0] ? res2.data.data.data[0].angry_reacted_users : res2.data.data.data[0].angry_reacted_users
                this.poll.my_reaction = res2.data.data.data[0] ? res2.data.data.data[0].my_reaction : res2.data.data.data[0].my_reaction
                this.poll.reaction = res2.data.data.data[0] ? res2.data.data.data[0].reaction : res2.data.data.data[0].reaction
                this.getAllReactions()
                this.posting = false
              })
              .catch(err => {
                this.$notification.error({ message: "Error - R4", description: "Updated reacted users cannot be fetched" })
                this.posting = false
              })
          } else if (this.fromProfileSaved) {
            console.warn("fromProfileSaved")
            this.$http
              .get(
                `${process.env.BASE_API_URL}/reactionsfavoritelist/?user=${this.authUser.user.id}&reacted_on_id=${this.poll.postId}&circle_id=${this.currentCircle.id}&reacted_on_type=5&role=${this.authUser.user.role}&page_num=1&items=1`,
                { headers }
              )
              .then(res2 => {
                this.poll.hugs_reacted_users = res2.data.data.data[0].favorite[0].hugs_reacted_users
                this.poll.happy_reacted_users = res2.data.data.data[0].favorite[0].happy_reacted_users
                this.poll.sad_reacted_users = res2.data.data.data[0].favorite[0].sad_reacted_users
                this.poll.likes_reacted_users = res2.data.data.data[0].favorite[0].likes_reacted_users
                this.poll.angry_reacted_users = res2.data.data.data[0].favorite[0].angry_reacted_users
                this.poll.my_reaction = res2.data.data.data[0].favorite[0].my_reaction
                this.poll.reaction = res2.data.data.data[0].favorite[0].reaction
                this.getAllReactions()
                this.posting = false
              })
              .catch(err => {
                this.$notification.error({ message: "Error - R5", description: "Updated reacted users cannot be fetched" })
                this.posting = false
              })
          } else {
            console.warn("ELSE")
            this.$http
              .get(`${process.env.BASE_API_URL}/dovemedpost/?id=${this.poll.postId}&circle_id=${this.currentCircle.id}&page_num=1&items=1`, {
                headers,
              })
              .then(res2 => {
                this.poll.hugs_reacted_users = res2.data.data.data[0].user_poll.hugs_reacted_users
                this.poll.happy_reacted_users = res2.data.data.data[0].user_poll.happy_reacted_users
                this.poll.sad_reacted_users = res2.data.data.data[0].user_poll.sad_reacted_users
                this.poll.likes_reacted_users = res2.data.data.data[0].user_poll.likes_reacted_users
                this.poll.angry_reacted_users = res2.data.data.data[0].user_poll.angry_reacted_users
                this.poll.my_reaction = res2.data.data.data[0].user_poll.my_reaction
                this.poll.reaction = res2.data.data.data[0].user_poll.reaction
                this.getAllReactions()
                this.posting = false
              })
              .catch(err => {
                this.$notification.error({ message: "Error - R6", description: "Updated reacted users cannot be fetched" })
                this.posting = false
              })
          }
        })
        .catch(err => {
          this.posting = false
        })
    },

    deleteReaction(reactionId, type) {
      const MIRROR_REACTION_TYPES = {
        1: "hugs",
        2: "likes",
        4: "favorites",
        8: "happy",
        9: "sad",
        10: "angry",
      }
      this.posting = true
      const reactions = this.getReaction(reactionId)

      let ids = ""
      ids = reactions.map(reaction => {
        return reaction.id
      })

      const user = JSON.parse(localStorage.getItem("user"))
      const headers = {
        Authorization: `Bearer ${user.user.token}`,
      }
      this.$http
        .delete(`${process.env.BASE_API_URL}/reactions/?ids=${ids.toString()}`, { headers })
        .then(res => {
          this.reactions[type] = false
          this.posting = false
          if (this.poll.reaction[type]) {
            this.poll.reaction[type] -= 1
          }
          // remove from my reaction
          this.poll.my_reaction = this.poll.my_reaction.filter(r => r.reaction_type !== reactionId)
          eval(
            `this.poll.${MIRROR_REACTION_TYPES[reactionId]}_reacted_users =
                this.poll.${MIRROR_REACTION_TYPES[reactionId]}_reacted_users
                  .filter(user => {
                    return user.id !== this.authUser.user.id;
                  })`
          )
        })
        .catch(err => {
          this.posting = false
        })
    },

    fetchPollComments(append = false) {
      // console.log("fetching Poll comments");
      // this.showWritable = true;
      this.loadingScreen = true
      if (!append) {
        this.comments = []
      }
      PostRepository.userPollComments(this.poll.id, this.currentPage, 1, this.currentCircle.id, !this.notificationCommentCalled ? this.commentId : null)
        .then(res => {
          if (this.commentId && !this.notificationCommentCalled) {
            this.notificationCommentCalled = true
          }
          if (append) {
            this.comments.push(...res.data.data.data)
          } else {
            if (res.data.data) {
              this.comments = res.data.data.data || []
              this.pagination = res.data.data.paginator || {}
            }
          }
          // console.log("comments ->", this.comments);
          this.currentPage += 1
          // this.showWritable = true;
          this.loadingScreen = false
        })
        .catch(err => {
          this.loadingScreen = false
          console.log(err)
        })
    },
    lighten(col, amt) {
      var usePound = false

      if (col[0] == "#") {
        col = col.slice(1)
        usePound = true
      }

      var num = parseInt(col, 16)

      var r = (num >> 16) + amt

      if (r > 255) r = 255
      else if (r < 0) r = 0

      var b = ((num >> 8) & 0x00ff) + amt

      if (b > 255) b = 255
      else if (b < 0) b = 0

      var g = (num & 0x0000ff) + amt

      if (g > 255) g = 255
      else if (g < 0) g = 0

      return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16)
    },
    /**
     * Handle image Upload
     */
    async handlePicUpload() {
      this.isImageUploading = true
      const file = this.$refs.fileInput.files[0]
      try {
        if (file.size / (1024 * 1024) > 5) {
          this.$notification.error({
            message: "Error",
            description: "File size exceeds 5MB limit",
          })
          // const input = this.$refs.fileInput
          // input.type = "text"
          // input.type = "file"
        } else if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image",
          })
        } else {
          const urlPayload = { file_name: [file.name] }
          const urlData = await UserRepository.getPresignedUrl(urlPayload)
          const fileName = urlData.data.data.filename[0]
          await s3Upload(urlData.data.data.url[0], file)
          this.comment_attach.push({ name: fileName, sensitive: false })
          const fileListData = {
            uid: this.comment_attach.length,
            name: file.name,
            status: "done",
            url: urlData.data.data.preview_url,
          }
          this.loading = false
          this.fileList.push(fileListData)
        }
      } catch (err) {}
      this.isImageUploading = false
    },
    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    async handleChange(data) {
      this.fileList.length === 1 ? (this.fileList = []) : this.fileList.splice(data.file.uid - 1, 1)
      this.comment_attach.splice(data.file.uid - 1, 1)
    },
    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        // (days > 545)
        return years + " years ago"
      }
    },
    handleSubmitChoice(id) {
      this.choice = id
      this.disabled = true
      const data = {
        user_circle: this.currentCircle.id,
        user: this.authUser.user.id,
        poll: this.poll.id,
        choice: this.choice,
      }
      ResourceRepository.postPoll(data)
        .then(res => {
          this.$notification.success({ message: "Success", description: "Poll submitted successfully." })
          eventBus.$emit("refresh-resource-view")
          this.showPercent = true
          // ResourceRepository.getpoll(this.poll.id, 1, 5, this.currentCircle.id).then(res => {
          //   // console.log(res, "new poll data")
          //   this.poll = res.data.data.data[0]
          // })
          PostRepository.getAllTypeById("poll_id", this.poll.id, this.currentCircle.id).then(res => {
            // console.log("res")
            this.poll = { ...res.data.data.data[0].user_poll, postId: res.data.data.data[0].id }
          })
        })
        .catch(err => console.error(err))
    },
    viewProfile() {
      if (this.poll.user.role === "admin") {
        return
      }
      // this.loadingScreen = true
      const user = this.poll.user
      if (user.id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        this.$store.commit("User/setViewUser", { data: { ...this.viewUser, isDirectory: false } })
        switch (user.role) {
          case "doctor":
          case "physician":
          case "hcp":
            this.$router.push({ name: "ViewDoctorUpdates", params: { id: user.id } })
            break
          case "clinic_administrator":
            this.$router.push({ name: "ViewClinicAbout", params: { id: user.id } })
            break
          case "hospital_administrator":
            this.$router.push({ name: "ViewHos_adminAbout", params: { id: user.id } })
            break
          case "nfp":
            this.$router.push({ name: "ViewNfpAbout", params: { id: user.id } })
            break
          case "patient":
            this.$router.push({ name: "ViewPatientUpdates", params: { id: user.id } })
            break
          case "caregiver":
            this.$router.push({ name: "ViewPatientUpdates", params: { id: user.id, role: "caregiver" } })
            break
          case "advocate":
            this.$router.push({ name: "ViewAdvocateAbout", params: { id: user.id } })
            break
          case "hospital":
            this.$router.push({ name: "HospViewAbout", params: { id: user.id } })
            break
          case "clinic":
            this.$router.push({ name: "ClinicViewAbout", params: { id: user.id } })
            break
          case "nfp_administrator":
            this.$router.push({ name: "ViewNfpAdminAbout", params: { id: user.id } })
            break
          default:
            break
        }
      }
    },
    savePoll() {
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }
      if (!this.pollSaved) {
        PostRepository.saveReaction(this.currentCircle.id, {
          reacted_on_type: 5,
          reacted_on_id: this.poll.id,
          user: this.authUser.user.id,
          user_role: this.authUser.user.role || "",
          reaction_type: 4,
        })
          .then(res => {
            this.pollSaved = true
            // save the id
            // console.log(res.data);
            // console.log(res.data && res.data.data);
            this.poll.my_reaction.push(res.data.data)
            this.$notification.success({
              message: "Saved",
              description: "Poll has been saved",
            })
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: "Poll cannot be saved",
            })
          })
      } else {
        // console.log(this.poll.my_reaction);
        const saveId = this.poll.my_reaction.filter(r => r.reaction_type === 4)[0].id
        this.$http
          .delete(`${process.env.BASE_API_URL}/reactions/?ids=${saveId}`, {
            headers,
          })
          .then(res => {
            this.pollSaved = false
            if (this.fromProfileSaved) {
              this.fetchPosts()
            }
            this.$notification.success({
              message: "Unsaved",
              description: "Poll has been unsaved",
            })
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: "Poll cannot be unsaved",
            })
          })
      }
    },
    muteUser() {
      UserRepository.muteUser({ user_circle: this.currentCircle.id, user_id: this.poll.user.id, role: this.poll.user.role })
        .then(res => {
          this.$notification.success({
            message: "Muted",
            description: "This user has been muted successfully",
          })
          if (!this.fromShare) {
            this.fetchPosts()
          } else {
            this.$router.push({ name: "ActivityHome" })
          }
        })
        .catch(e => {
          this.$notification.error({
            message: "Error",
            description: "Cannot mute user",
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
hr {
  margin: 1rem -20px 0;
}
.post-image {
  width: 100%;
  height: 445px;
  object-fit: cover;
}
.options {
  width: 100%;
  height: auto !important;
  .option {
    position: relative;
    cursor: pointer;
    min-height: 55px;
    background-color: #f1f5f9;
    padding: 1rem;
    border-radius: 10px;
    margin-bottom: 1rem;
    .poll-option {
      position: absolute;
      left: 1rem;
      top: 1rem;
    }
    .percentage {
      position: absolute;
      right: 20px;
      top: 1rem;
    }
  }
}
.dot-menu-cont {
  position: absolute;
  top: 0;
  // right: 16px;
  right: 0;
  width: 20px;
  // height: 50%;
}
.post__tags {
  // margin: 10px;
  display: flex;
  // margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 5px;
  .tags {
    padding: 3px 16px;
    display: inline-block;
    font-weight: 700;
    font-size: 10px;
    // margin: 5px;
  }
  .popover-button {
    // margin: 5px;
    line-height: 1em;
    button {
      background: none;
      border: none;
    }
  }
}
.image-uploading {
  height: auto;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}
.comment-head {
  .title {
    font-size: 16px;
  }
}
.card-item {
  font-weight: 400 !important;
}
.spinnerContainer-post {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
  // z-index: 999;
}
.u-options div {
  padding-left: 6px !important;
}
.like-comment-gap {
  gap: 10%;
  @media screen and (max-width: 600px) {
    justify-content: space-between;
  }
}
@media screen and (max-width: 600px) {
  .name-with-poll {
    flex-direction: column;
    align-items: flex-start !important;
    .mx-2 {
      margin-left: 0 !important;
    }
  }
  .hide-comment {
    display: none;
  }
  // .u-options div {
  //   display: none;
  // }
  // div.like-text,
  // .reply-btns,
  // .showReactions,
  // .emojiReactions {
  //   display: block !important;
  // }
  .commentText {
    font-size: 12px !important;
  }
  .m-pl-30 {
    padding-left: 30px;
  }
}
p.cp.text-capitalize {
  word-break: break-word;
}
.showReactions {
  position: relative;
}
.emojiReactions {
  visibility: hidden;
  opacity: 0;
  z-index: -1;
  transform: translateY(30px);
  transition: all 1s;
  position: absolute;
  top: -60px;
  left: -20px;
}
.showReactions:hover .emojiReactions,
.emojiReactions:hover {
  visibility: visible;
  opacity: 1;
  z-index: 1;
  transform: translateY(0);
}
.poll-attempts {
  font-weight: 400;
  font-size: 16px;
  color: #647490;
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/poll/UserPollCard.vue